import { Alert, Box, Button, IconButton, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useScheduleEditorIds } from "./hooks/use-schedule-editor-ids"
import { useIsAuthoringScheduleEditor } from "./hooks/use-is-authoring-schedule-editor"
import { setReference, useReferenceState } from "lib/@hooks/use-reference"
import { useAuthoringRecommendationSummaryFromContext } from "./hooks/use-authoring-recommendation-summary"

const RECOMMENDATIONS_TAB_ID = "AuthoringRecommendations"

export function AuthoringRecommendationsNudge() {
    const { projectId, scheduleId } = useScheduleEditorIds()
    const isAuthoringScheduleEditor = useIsAuthoringScheduleEditor()
    const [currentTab] = useReferenceState("ScheduleRightBarTab", "")
    const [seenIds, setSeenIds] = useReferenceState(getSeenKey(projectId, scheduleId), [])
    const { summary, recommendationsLoading } = useAuthoringRecommendationSummaryFromContext()
    const { counts } = summary
    const unseenRecommendations = summary.items.filter((item) => item?.id && !seenIds.includes(item.id))

    if (!isAuthoringScheduleEditor) return null
    if (recommendationsLoading) return null
    if (!counts.unappliedCount) return null
    if (!unseenRecommendations.length) return null
    if (currentTab === RECOMMENDATIONS_TAB_ID) return null

    return (
        <Alert
            severity="info"
            sx={{ mb: 1 }}
            action={
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Button color="inherit" size="small" onClick={openRecommendations}>
                        Open
                    </Button>
                    <IconButton aria-label="Dismiss" size="small" color="inherit" onClick={dismiss}>
                        <Iconify icon="mdi:close" width={16} />
                    </IconButton>
                </Box>
            }
        >
            <Typography variant="body2">
                {counts.unappliedCount} recommendation{counts.unappliedCount === 1 ? "" : "s"} ready to review for this
                schedule.
            </Typography>
        </Alert>
    )

    function openRecommendations() {
        dismiss()
        setReference({ ScheduleRightBarTab: RECOMMENDATIONS_TAB_ID }, "tab-ScheduleRightBar-")
    }

    function dismiss() {
        setSeenIds((current = []) => mergeSeenIds(current, unseenRecommendations))
    }
}

function mergeSeenIds(current, recommendations) {
    return Array.from(
        new Set([
            ...(Array.isArray(current) ? current : []),
            ...recommendations.map((item) => item?.id).filter(Boolean),
        ])
    )
}

function getSeenKey(projectId, scheduleId) {
    return `authoring-recommendations-seen:${projectId}:${scheduleId}`
}
